import cn from '@/lib/cn'
import { btnClass, ButtonType } from '../@legacy/Button'

export interface LinkButtonProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  buttonType?: ButtonType
  loading?: boolean
  size?: 'sm' | 'md' | 'lg'
}

const LinkButton = ({
  buttonType = ButtonType.default,
  className,
  children,
  loading,
  size = 'md',
  ...rest
}: LinkButtonProps) => {
  return (
    <a
      className={cn(
        'btn rounded-lg inline-block text-center',
        btnClass[buttonType],
        {
          'px-4 py-2.5 text-sm leading-4': size === 'sm',
          'px-6 py-3 text-base leading-6': size === 'md',
          'px-8 py-3.5 text-lg leading-7': size === 'lg',
        },
        className,
      )}
      {...rest}
    >
      {loading ? <span className="btn-loading-spinner" /> : children}
    </a>
  )
}

export default LinkButton
